__turbopack_context__.v({
  "summary": "ProductSummary-module-scss-module__TA-e4W__summary",
  "summary__cart": "ProductSummary-module-scss-module__TA-e4W__summary__cart",
  "summary__details": "ProductSummary-module-scss-module__TA-e4W__summary__details",
  "summary__header": "ProductSummary-module-scss-module__TA-e4W__summary__header",
  "summary__list-link": "ProductSummary-module-scss-module__TA-e4W__summary__list-link",
  "summary__lists": "ProductSummary-module-scss-module__TA-e4W__summary__lists",
  "summary__price": "ProductSummary-module-scss-module__TA-e4W__summary__price",
  "summary__price-note": "ProductSummary-module-scss-module__TA-e4W__summary__price-note",
  "summary__qty": "ProductSummary-module-scss-module__TA-e4W__summary__qty",
  "summary__rating": "ProductSummary-module-scss-module__TA-e4W__summary__rating",
  "summary__rating-link": "ProductSummary-module-scss-module__TA-e4W__summary__rating-link",
  "summary__rating-text": "ProductSummary-module-scss-module__TA-e4W__summary__rating-text",
  "summary__shipping": "ProductSummary-module-scss-module__TA-e4W__summary__shipping",
  "summary__sku": "ProductSummary-module-scss-module__TA-e4W__summary__sku",
  "summary__status-tag": "ProductSummary-module-scss-module__TA-e4W__summary__status-tag",
  "summary__title": "ProductSummary-module-scss-module__TA-e4W__summary__title",
});
